import { useSelector } from 'react-redux';

import { IAppState } from '../../../../common/state';
import { EOfficeType } from '../../../../repositories/common/json_query';

export function useIsCoworkingProfitBannerEnabled() {
  return useSelector<IAppState, boolean>(state => {
    const {
      results: {
        jsonQuery: { _type, office_type },
      },
    } = state;

    return (
      _type === 'commercialrent' &&
      office_type?.value.length === 1 &&
      [EOfficeType.Office, EOfficeType.Coworking].some(el => el === office_type?.value[0])
    );
  });
}
